
const defaults = {
	ready: false,
	shareData: null,
	showInvitationCard: false
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'UPDATE_SHARE_DATA': {
			if(action.payload.link[0] === '/'){
				action.payload.link = location.protocol + '//' + location.host + action.payload.link;
			}
			return {...state, shareData:action.payload};
		}
		case 'WECHAT_SET_READY':
			return {...state, ready: true};
		case 'WECHAT_INIT':
			return {...state, ready: false};
		case 'WECHAT_SHOW_CARD':
			return {...state, showInvitationCard: action.payload.show};
		default: {
			return state;
		}
	}
} 




// WEBPACK FOOTER //
// ./src/reducers/wechat.js